import { IComparisonVolume } from '@nkr/models/index';

interface IProps {
    index: number,
    item: IComparisonVolume,
    includeDash: boolean,
    includeDcn: boolean,
    includeNkr: boolean,
    centerId: number
}

const DataRow = (props: IProps) => {
    let { item } = props;

    return (
        <tr>
            <td>{props.index + 1}</td>
            <td>{item.centerAlias}</td>
            <td>{item.monthsAgo11}</td>
            <td>{item.monthsAgo10}</td>
            <td>{item.monthsAgo9}</td>
            <td>{item.monthsAgo8}</td>
            <td>{item.monthsAgo7}</td>
            <td>{item.monthsAgo6}</td>
            <td>{item.monthsAgo5}</td>
            <td>{item.monthsAgo4}</td>
            <td>{item.monthsAgo3}</td>
            <td>{item.monthsAgo2}</td>
            <td>{item.lastMonth}</td>
            <td>{item.thisMonth}</td>
            <td>{item.total}</td>
        </tr>
    );
}

export default DataRow;